import { createSlice } from '@reduxjs/toolkit';
import { cmsApi } from '../../apis/cmsApi/cms.api';
import { CmsConfigs, Operation } from '../../models';
import {
  isAppInitializedReducer,
  addLoaderFullPageReducer,
  removeLoaderFullPageReducer,
  setCmsConfigReducer,
  setCurrentOrderIdReducer,
  addRouteToHistoryReducer,
  removeLastRouteFromHistoryReducer,
  replaceLastRouteFromHistoryReducer,
  setOperationReducer,
  setErrorDescriptionReducer,
} from './general.reducer';

export interface GeneralState {
  loadersFullPage: string[];
  isAppInitialized: boolean;
  cmsConfigs: CmsConfigs | null;
  currentOrderId: string | null;
  routesHistory: string[];
  operation: Operation | null;
  errorDescription: string | null;
}

export const initialGeneralState: GeneralState = {
  loadersFullPage: [],
  isAppInitialized: false,
  cmsConfigs: null,
  currentOrderId: null,
  routesHistory: [],
  operation: null,
  errorDescription: null,
};

export const generalSlice = createSlice({
  name: 'general',
  initialState: initialGeneralState,
  reducers: {
    addLoaderFullPage: addLoaderFullPageReducer,
    removeLoaderFullPage: removeLoaderFullPageReducer,
    setIsAppInitialized: isAppInitializedReducer,
    setCurrentOrderId: setCurrentOrderIdReducer,
    addRouteToHistory: addRouteToHistoryReducer,
    removeLastRouteFromHistory: removeLastRouteFromHistoryReducer,
    replaceLastRouteFromHistory: replaceLastRouteFromHistoryReducer,
    setOperation: setOperationReducer,
    setErrorDescription: setErrorDescriptionReducer,
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      cmsApi.endpoints.getCmsConfigs.matchFulfilled,
      setCmsConfigReducer
    );
  },
});

export const generalActions = generalSlice.actions;
export const generalReducer = generalSlice.reducer;
